import { TrashIcon } from "@heroicons/react/24/outline";
import { CollegeProduct } from "data/data";
import { FC,useState } from "react";
import toast from "react-hot-toast";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import { useDeleteFromWaitListMutation } from "store/api/productsApi";
import ConfirmDialog from "./ConfirmDialog";
import Prices from "./Prices";

export interface WaitListProductCardProps {
  className?: string;
  data: CollegeProduct;
  onRemove: (productId: string) => void;
}

const WaitListProductCard: FC<WaitListProductCardProps> = ({
  className = "",
  data,
}) => {
  const {
    id,
    name,
    price,
    type,
    image,
    price_html,
  } = data;
  const [deleteFromWaitList, {isLoading: isLoadingDeleteFromWaitList}] = useDeleteFromWaitListMutation()
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const notifyRemoveFromWaitlist = () => {
    toast.success("Eliminado de la lista de espera");
  };


  const handleRemoveFromWaitlist = async () => {
    const res = await deleteFromWaitList(id)
    if(res.error){
      toast.error(res?.error?.data?.message || "Ha ocurrido un error")
    }else{
      notifyRemoveFromWaitlist();
    }
  };

  return (
    <>
      <div
        className={`nc-ProductCard relative flex flex-col bg-transparent ${className}`}
        data-nc-id="ProductCard"
        onClick={()=>window.scrollTo(0, 0)}
      >

        <div className="relative flex-shrink-0 bg-slate-50 dark:bg-slate-300 rounded-3xl overflow-hidden z-1 group">
            <NcImage
              containerClassName="flex aspect-[11/12] w-full"
              src={image}
              className="object-cover w-full h-full"
            />
        </div>

        <div className="space-y-4 px-2.5 pt-5 pb-2.5">
          <div>
            <h2
              className={`nc-ProductCard__title text-base font-semibold transition-colors`}
            >
              {name}
            </h2>
            {type === 'variation' && data.attributes.length > 0 && (
              <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                {data.attributes.map((attribute, index) => (
                  <div key={attribute.name} className="flex">
                    <span className="font-medium">{attribute.name}:</span>
                    <span className="ml-1">{attribute.terms[0].name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="flex justify-between items-end ">
            <Prices price={price} price_html={price_html} />
            <div className="flex space-x-2">
              <ButtonPrimary
                className="shadow-lg"
                sizeClass="py-2 px-4"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowConfirmDialog(true);
                }}
              >
                <TrashIcon className="w-3.5 h-3.5" />
                <span className="ml-1">Eliminar</span>
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>

      {/* CONFIRM DIALOG */}
      <ConfirmDialog
        open={showConfirmDialog}
        hide={() => setShowConfirmDialog(false)}
        title="Eliminar de la lista de espera"
        isLoading={isLoadingDeleteFromWaitList}
        desc={`¿Estás seguro de que deseas eliminar "${name}" de tu lista de espera?`}
        onConfirm={handleRemoveFromWaitlist}
      />
    </>
  );
};

export default WaitListProductCard;
